import QueryStringUtil from '@/common/query'

export enum PhysicsLayerZ {
  Front = 3,
  Back = 0,
  Revealed = 5,
  UI = 4,
  MonsterMouth = 1
}

export const MATTER_SCALE = 100
export const MATTER_TO_THREE_SCALE = 0.01
export const MODEL_IMPORT_SCALE = 100
export const TEST_ESCAPED_COINS_INTERVAL = 300

export const GLOBAL_COIN_SCALE = Number(QueryStringUtil.get('globalscale') ? QueryStringUtil.get('globalscale') : 0.8)

export const CAMERA_ANIMATION_DURATION_OUT = 0.3
export const CAMERA_ANIMATION_DURATION_IN = 0.7

export enum ColliderType {
  NAVIGATION = 'navigation',
  ACTION = 'action',
  SENSOR = 'sensor',
  COLLIDER = 'collider'
}

export enum ColliderActionType {
  COMBINE = 'combine',
  ADD_COIN = 'addCoin',
  ADD_PARENT_COIN_1 = 'addParentCoin1',
  ADD_PARENT_COIN_10 = 'addParentCoin10',
  ADD_PARENT_COIN_100 = 'addParentCoin100',
  CLOSE_TUBE = 'close-tube',
  TAP_BACKGROUND = 'tap-background'
}

export const SLIT_DIVIDE_BODY_LABEL = 'slit_divide'
export const SLIT_COMBINE_BODY_LABEL = 'slit_combine'
export const BODY_LABEL_ADDON_ANIMATION = '-animated'
export const BODY_LABEL_ADDON_ZOOMED_IN = '-zoomed'
export const BODY_LABEL_ADDON_FROM_SLIT = '-fromSlit'
export const BODY_LABEL_ADDON_REVEALED = '-revealed'
export const BODY_LABEL_EPHEMERAL_TOOL = '-emphemeralTool'

export enum SpawnLocation {
  Transfer = 'transfer',
  TransferParentSlit = 'transfer_parent_slit',
  Tube = 'tube',
  Wallet = 'wallet',
  WalletCombine = 'wallet_combine',
  WalletDivide = 'wallet_divide',

  TopSlit = 'top_slit',
  BottomSlit = 'bottom_slit',
  LeftSlit = 'left_slit',
  RightSlit = 'right_slit',

  InRoom = 'in_room',
  Center = 'center'
}
